var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataTable, DateField } from 'react-admin';
import { AuthorField } from '../AuthorField';
import { ActionField } from '../ActionField';
import { ResourceField } from '../ResourceField';
import { useGetActionLink } from '../useGetActionLink';
export var EventDataTable = function (props) {
    var authorResource = props.authorResource, rest = __rest(props, ["authorResource"]);
    var getActionLink = useGetActionLink();
    var handleRowClick = function (id, resource, record) { var _a; return (_a = getActionLink(record)) !== null && _a !== void 0 ? _a : false; };
    return (_jsxs(DataTable, __assign({ rowClick: handleRowClick, bulkActionButtons: false }, rest, { children: [_jsx(DataTable.Col, { source: "date", field: DateField }), _jsx(DataTable.Col, { source: "resource", children: _jsx(ResourceField, { source: "resource" }) }), _jsx(DataTable.Col, { source: "author", children: _jsx(AuthorField, { authorResource: authorResource, source: "author" }) }), _jsx(DataTable.Col, { source: "action", children: _jsx(ActionField, { source: "action" }) })] })));
};
// For backward compatibility
export var EventDatagrid = EventDataTable;
